// extracted by mini-css-extract-plugin
export var actions = "Action-module--actions--HIklc";
export var component = "Action-module--component--xIgp+";
export var componentInner = "Action-module--componentInner--2EY-E";
export var heading = "Action-module--heading--pQbFk";
export var label = "Action-module--label--i29Ae";